<template>
  <DealList module="call-center" />
</template>

<script>
import DealList from "@/components/deals/DealList.vue";

export default {
  name: "CallCenterDeal",
  components: {
    DealList
  }
};
</script>
